module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/card/answer/card-answer.component.scss
// module id = ./src/app/remote/card/answer/card-answer.component.scss
// module chunks = main